import { CardNetwork } from "../enum/card-network.enum.js";
import { ThaiBank } from "../enum/thai-bank.enum.js";
// Order matters: KTC (Krungthai Card) must win over the KTB aliases.
const BANK_ALIASES = [
    [ThaiBank.Ktc, ["ktc", "krungthai card", "เคทีซี", "กรุงไทยคาร์ด"]],
    [ThaiBank.Ktb, ["ktb", "krungthai", "กรุงไทย"]],
    [ThaiBank.Kbank, ["kbank", "kasikorn", "กสิกร"]],
    [ThaiBank.Scb, ["scb", "siam commercial", "ไทยพาณิชย์"]],
    [ThaiBank.Bbl, ["bangkok bank", "bbl", "กรุงเทพ"]],
    [ThaiBank.Bay, ["krungsri", "ayudhya", "กรุงศรี"]],
    [ThaiBank.Ttb, ["ttb", "tmb", "thanachart", "ทีทีบี"]],
    [ThaiBank.Uob, ["uob", "ยูโอบี"]],
    [ThaiBank.Gsb, ["gsb", "ออมสิน"]],
    [ThaiBank.Ghb, ["ghb", "อาคารสงเคราะห์"]],
    [ThaiBank.Baac, ["baac", "ธ.ก.ส"]],
    [ThaiBank.Cimb, ["cimb"]],
    [ThaiBank.Citi, ["citibank", "citi bank"]],
    [ThaiBank.Hsbc, ["hsbc"]],
    [ThaiBank.Ibank, ["ibank", "islamic bank", "อิสลาม"]],
    [ThaiBank.Icbc, ["icbc"]],
    [ThaiBank.Kkp, ["kkp", "kiatnakin", "เกียรตินาคิน"]],
    [ThaiBank.Lhb, ["lhb", "land and houses", "land & houses"]],
    [ThaiBank.Tcrb, ["tcrb", "thai credit", "ไทยเครดิต"]],
    [ThaiBank.Tisco, ["tisco", "ทิสโก้"]],
    [ThaiBank.TrueMoney, ["truemoney", "true money", "ทรูมันนี่"]],
    [ThaiBank.PromptPay, ["promptpay", "พร้อมเพย์"]],
];
/** First bank, card issuer or wallet named in any of the texts, else null. */
export function detectBank(...texts) {
    const haystack = texts.filter(Boolean).join(" ").toLowerCase();
    if (!haystack)
        return null;
    for (const [bank, aliases] of BANK_ALIASES) {
        if (aliases.some((alias) => haystack.includes(alias)))
            return bank;
    }
    return null;
}
const NETWORK_WORDS = [
    [CardNetwork.Visa, /\bvisa\b/i],
    [CardNetwork.Mastercard, /master\s?card/i],
    [CardNetwork.Jcb, /\bjcb\b/i],
    [CardNetwork.Amex, /\bamex\b|american\s+express/i],
    [CardNetwork.UnionPay, /union\s?pay/i],
];
/** Network from the card number's leading digits (issuer identification range). */
function networkFromCardNumber(cardNumber) {
    const digits = cardNumber.replace(/\D/g, "");
    const two = Number(digits.slice(0, 2));
    const four = Number(digits.slice(0, 4));
    if (digits.length < 2)
        return null;
    if (digits[0] === "4")
        return CardNetwork.Visa;
    if (two === 34 || two === 37)
        return CardNetwork.Amex;
    if (two === 35)
        return CardNetwork.Jcb;
    if (two === 62)
        return CardNetwork.UnionPay;
    if ((two >= 51 && two <= 55) || (four >= 2221 && four <= 2720)) {
        return CardNetwork.Mastercard;
    }
    return null;
}
/** Card network named in the texts (name, card type) or implied by the card number. */
export function detectCardNetwork(texts, cardNumber) {
    const haystack = texts.filter(Boolean).join(" ");
    for (const [network, pattern] of NETWORK_WORDS) {
        if (pattern.test(haystack))
            return network;
    }
    return cardNumber ? networkFromCardNumber(cardNumber) : null;
}
//# sourceMappingURL=account-brand.js.map